import {ThreeTsl as TSL} from "#material/three/exports"
import type {Three as THREE} from "#material/three/exports"

export const threeAdjust = TSL.Fn(([hsvIn, h, s, v]: [hsvIn: THREE.Node<"vec3">, h: THREE.Node<"float">, s: THREE.Node<"float">, v: THREE.Node<"float">]) => {
    const hsvOut = TSL.vec3(0).toVar()

    hsvOut.x.assign(TSL.mod(hsvIn.x.add(h).add(0.5), 1.0))
    hsvOut.y.assign(TSL.max(0.0, TSL.min(1.0, hsvIn.y.mul(s))))
    hsvOut.z.assign(hsvIn.z.mul(v))

    return hsvOut
})

export const threeFacAndClamp = TSL.Fn(([rgbIn, rgbAdj, f]: [rgbIn: THREE.Node<"color">, rgbAdj: THREE.Node<"color">, f: THREE.Node<"float">]) => {
    const rgbOut = TSL.color(0).toVar()

    rgbOut.r.assign(f.mul(rgbAdj.r).add(TSL.float(1.0).sub(f).mul(rgbIn.r)))
    rgbOut.g.assign(f.mul(rgbAdj.g).add(TSL.float(1.0).sub(f).mul(rgbIn.g)))
    rgbOut.b.assign(f.mul(rgbAdj.b).add(TSL.float(1.0).sub(f).mul(rgbIn.b)))

    rgbOut.r.assign(TSL.max(rgbOut.r, 0.0))
    rgbOut.g.assign(TSL.max(rgbOut.g, 0.0))
    rgbOut.b.assign(TSL.max(rgbOut.b, 0.0))

    return rgbOut
})
